import { Container } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../../pages";
import type { FooterProps } from "../types";
import { FooterContent } from "./FooterContent";
import "./Footer.css";

export const Footer = (props: WithMetadata<FooterProps>) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;

  const classes = classNames("mobius", "mobius-footer-ctm", className);
  const { variant } = otherProps;

  return (
    <footer
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <Container size="sm" className="mobius-footer-ctm__content">
        <FooterContent />
      </Container>
    </footer>
  );
};
